import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta03 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-03/utils-consultaSeguimentoPergunta03'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta03 } from './converter-HistoricoMchatPergunta03'

interface HistoricoMChatRfPergunta03Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta03 = (props: Readonly<HistoricoMChatRfPergunta03Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta03(aplicacoes)
  if (converted == null) return null

  const { header, perguntas, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta03(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='3'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“O seu filho alguma vez...”'
      />
      <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
